import { render, staticRenderFns } from "./GlobalQuotePortrait.vue?vue&type=template&id=583b81f6&name=global-quote-portrait&"
import script from "./GlobalQuotePortrait.vue?vue&type=script&lang=js&"
export * from "./GlobalQuotePortrait.vue?vue&type=script&lang=js&"
import style0 from "./GlobalQuotePortrait.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports